<template>
  <TablaDatosAPI
    ref="regevesag"
    v-bind="$attrs"
    icono="mdi-comment-processing-outline"
    tabla="v_regevesag"
    :campos="['fechor+', 'id_ins', 'id_apa', 'id_tipeve', 'desgrupro', 'numpro', 'matrec', 'tie-', 'imp-', 'salcon-', 'saldis-', 'nomcomope-']"
    :campos-filtrables="camposFiltrables"
    :evento-antes-procesar-respuesta-servidor="eventoAntesProcesarRespuestaServidor"
    :parametros="parametros"
    :deshabilitarOrdenar="true"
    :loader-height="0"
  >
    <template v-slot:[`item.fechor__VT`]="{ item }">
      <span style="white-space: nowrap">
        {{item.fechor__VT}}
      </span>
    </template>

    <template v-slot:[`item.id_apa__VT`]="{ item }">
      <span style="white-space: nowrap">
        <span      v-if="item.id_tipapa == 5"><v-icon color="#659567" class="mr-1">mdi-location-enter</v-icon></span>
        <span v-else-if="item.id_tipapa == 6"><v-icon color="#50779f" class="mr-1">mdi-location-exit mdi-flip-h</v-icon></span>
        <span v-else-if="item.id_tipapa == 7"><v-icon color="#cfaf50" class="mr-1">mdi-chevron-right-circle-outline</v-icon></span>
        <span v-else-if="item.id_tipapa == 9"><v-icon color="#9f5077" class="mr-1">mdi-transit-transfer</v-icon></span>
        {{item.id_apa__VT}}
      </span>
    </template>

    <template v-slot:[`item.id_tipeve`]="{ item }">
      <span v-if="item.id_tipeve == 20" style="font-weight: 500">
        <v-icon      v-if="item.id_tipinc < 100"  color="#0088e3" class="mr-1">mdi-information-variant</v-icon>
        <v-icon v-else-if="item.id_tipinc < 200"  color="#f39800" class="mr-1">mdi-alert</v-icon>
        <v-icon v-else-if="item.id_tipinc < 300"  color="#EF5350" class="mr-1">mdi-alert-circle</v-icon>
        <v-icon v-else-if="item.id_tipinc < 400"  color="#D50000" class="mr-1">mdi-close-circle</v-icon>
        <v-icon v-else-if="item.id_tipinc < 500"  color="#B5B575" class="mr-1">mdi-checkbox-outline</v-icon>
        <v-icon v-else-if="item.id_tipinc < 600"  color="#FFCA28" class="mr-1">mdi-star</v-icon>
        <v-icon v-else-if="item.id_tipinc < 700"  color="#6D4C41" class="mr-1">mdi-timer-sand</v-icon>
        <v-icon v-else-if="item.id_tipinc < 800"  color="#E65100" class="mr-1">mdi-lock</v-icon>
        <v-icon v-else-if="item.id_tipinc < 900"  color="#0088e3" class="mr-1">mdi-message-text</v-icon>
        <v-icon v-else-if="item.id_tipinc < 1000" color="#78AC90" class="mr-1">mdi-message-alert</v-icon>
        <v-icon v-else-if="item.id_tipinc < 1100" color="#f39800" class="mr-1">mdi-message-alert</v-icon>
        <v-icon v-else-if="item.id_tipinc < 1200" color="#EF5350" class="mr-1">mdi-message-alert</v-icon>
        <v-icon    v-else                         color="#f39800" class="mr-1">mdi-help-circle</v-icon>
        {{item.id_tipinc__VT}}
        <span style="font-weight: 300" class="ml-3">{{item.infvar}}</span>
      </span>
      <span      v-if="item.id_tipeve == 15" style="font-weight: 500"><v-icon color="#659567" class="mr-1">mdi-arrow-right-bold</v-icon>{{ $t ('Entrada') }}</span>
      <span v-else-if="item.id_tipeve == 16" style="font-weight: 500"><v-icon color="#50779f" class="mr-1">mdi-arrow-left-bold</v-icon>{{ $t ('Salida') }}</span>
      <span v-else-if="item.id_tipeve == 18" style="font-weight: 500"><v-icon color="#50779f" class="mr-1">mdi-arrow-left-bold</v-icon>{{ $t ('Paso') }}</span>
      <span v-else-if="item.id_tipeve == 40"  style="font-weight: 500">
          <v-icon color="#4DB6AC" class="mr-1">mdi-cash</v-icon>{{ $t ('Cobro') }}
          <span style="font-weight: 300" class="ml-3">{{ item.infvar }}{{ item.infvar ? ': ' : '' }}{{ $t ('Importe') }}: {{ $utilI18N.cadenaImporte (item.imp) }}</span>
      </span>
    </template>

    <template v-slot:[`item.numpro`]="{ item }">
      <span class="numero-producto">{{ item.numpro }}</span>
    </template>

    <template v-slot:[`item.matrec`]="{ item }">
      <template v-if="item.matrec">
        <span v-if="item.matrec.substring (0,1)=='+'" class="matricula" style="background: #DAFFDA">{{ item.matrec.slice(1) }}</span>
        <span v-else class="matricula">{{ item.matrec }}</span>
      </template>
    </template>

  </TablaDatosAPI>
</template>

<script>
import TablaDatosAPI from "@/components/TablaDatosAPI.vue";

export default {
  components: {
    TablaDatosAPI
  },
  props: {
    idInstalacion: Number,
    idAparato: Number
  },
  data() {
    return {
      manejadorEscuchadorEventos: null,
      camposFiltrables: undefined,
      timeoutActualizarTabla: null,
      momentoUltimaActualizacionTabla: 0,
    }
  },
  computed: {
    parametros() {
      let objeto = {};
      if (this.idInstalacion) {
        objeto.idInstalacion = { valor: this.idInstalacion, descripcion: this.$t ('Instalación seleccionada') };
        if (this.idAparato)
          objeto.idAparato = { valor: this.idAparato, descripcion: '' };
      }
      return objeto;
    }
  },
  methods: {
    eventoAntesProcesarRespuestaServidor (definicionCampos) {
      this.camposFiltrables = ['fechor'];
      if (this.idInstalacion === undefined)
        this.camposFiltrables.push ('id_ins');

      if (definicionCampos) {
        definicionCampos.id_ins.visibilidad = this.idInstalacion ? "-": definicionCampos.id_ins.visibilidad;
        definicionCampos.id_apa.visibilidad = this.idAparato ? "-" : definicionCampos.id_apa.visibilidad;
      }
    },
    notificacionEventoSAGA () {
      if (!this.timeoutActualizarTabla) {
        let transcurrido = Date.now() - this.momentoUltimaActualizacionTabla;
        if (transcurrido > 2000) transcurrido = 2000;
        let delay = 2000 - transcurrido;
        this.timeoutActualizarTabla = setTimeout (() => {
          this.$refs['regevesag'].actualizarDatos();
          this.momentoUltimaActualizacionTabla = Date.now();
          this.timeoutActualizarTabla = null;
        }, delay);
      }
    }
  },
  created() {
    let idInstalacionAEscuchar = this.idInstalacion ? this.idInstalacion : '*';
    this.manejadorEscuchadorEventos = this.$sagabroker.anadirEscuchadorTema ('aparcamiento/'+idInstalacionAEscuchar+'/eventos/*', this.notificacionEventoSAGA);
  },
  destroyed() {
    if (this.manejadorEscuchadorEventos)
      this.$sagabroker.eliminarEscuchadorTema (this.manejadorEscuchadorEventos);
  }
}
</script>

<style scoped>
</style>